export default __webpack_public_path__ + "static/media/mf.fc26095f.svg";